export default __webpack_public_path__ + "static/media/alarm.b51b6f9a.svg";